export const STATE = {

    "OPEN": "OPEN",
    "ON_HOLD": "ON_HOLD",
    "CANCELED": "CANCELED",
    "CLOSED": "CLOSED"
};

export type StateType = typeof STATE[keyof typeof STATE];